module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/person-with-box/person-with-box@3x.svg"